<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="this.btnRegisterReadColor" v-if="result.basic.act === false">
        lock
      </v-icon>
      <v-icon :color="this.btnRegisterReadColor" v-else-if="result.basic.save === false">
        save
      </v-icon>
      <v-icon :color="this.btnRegisterReadColor" v-else>
        text_snippet
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <span :class="ui.textTitle">
              {{item.title}}
            </span>
            <v-spacer/>
            <span :class="ui.textTitle">
              {{displayDocumentIDGTypeA(result.basic.tag, result.basic.idg)}}
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row v-if="result.basic.save === false">
            <v-spacer/>
            <span :class="ui.textSubheading">
              <v-chip large :color="ui.colorWarning" text-color="white">
                <v-avatar>
                  <v-icon>
                    warning
                  </v-icon>
                </v-avatar>
                <div :class="ui.textSubheadingBoldWhite">
                  Data updating by other user !
                </div>
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>
                    {{this.defineDocumentFromTag(result.basic.tag).icon}}
                  </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag(result.basic.tag).title}}
              </v-chip>
            </span>
            <v-spacer/>
            <span :class="ui.textSubheading"
            v-if="this.docIsArchived">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon :color="ui.colorWarning">
                    archive
                  </v-icon>
                </v-avatar>
                <span :class="ui.textWarning">
                  Archived
                </span>
              </v-chip>
            </span>
          </v-layout>
          <v-layout row>
            <span :class="ui.textSubheading"
            v-if="
                this.result.basic.id !== '' &&
                result.basic.tag !== 'O1'
            ">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>sell</v-icon>
                </v-avatar>
                {{result.basic.id}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" v-if="result.basic.act === false">
                <v-icon :color="ui.btnColor">
                  lock
                </v-icon>
              </v-chip>
            </span>
          </v-layout>
          <v-layout class="ml-3 mr-3 mt-1">
            <div :class="ui.textSubheadingBold">
              {{item.heading}}
            </div>
          </v-layout>
          <v-layout row v-if="result.basic.tag === 'B3'">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>share</v-icon>
                </v-avatar>
                {{result.basic.idm}}
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>
          <v-layout row v-if="result.basic.tag === 'B3'">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>account_balance</v-icon>
                </v-avatar>
                {{result.link.ct}}
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>
          <v-layout row v-if="result.basic.tag === 'B3'">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>place</v-icon>
                </v-avatar>
                {{result.link.ft}}
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>
          <v-layout row class="mt-4 mb-2"/>
          <v-layout row v-if="result.basic.tag === 'O1'">
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>grid_view</v-icon>
              </v-avatar>
              {{result.char.type}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>adjust</v-icon>
              </v-avatar>
              {{result.char.org}}
            </v-chip>
          </v-layout>
          <div v-if="result.basic.tag === 'W1' || result.basic.tag === 'W2'">
            <v-layout row>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>today</v-icon>
                </v-avatar>
                <span v-if="result.link.pt !== ''">
                  {{result.link.pt}}
                </span>
                <span v-else>
                  No Plan Assigned
                </span>
              </v-chip>
            </v-layout>
          </div>
          <div v-if="result.basic.tag === 'B4'">
            <v-layout row>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>today</v-icon>
                </v-avatar>
                {{this.dateTypeA(result.stats.dstr)}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>event</v-icon>
                </v-avatar>
                {{this.dateTypeA(result.stats.dend)}}
              </v-chip>
            </v-layout>
            <v-layout row>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>attach_money</v-icon>
                </v-avatar>
                {{result.char.coste}} {{result.char.costu}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>co2</v-icon>
                </v-avatar>
                {{result.char.carbe}} {{result.char.carbu}}
              </v-chip>
            </v-layout>
          </div>
          <v-layout row v-if="true">
            <span :class="ui.textSubheading" v-if="item.enableTrans">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{item.transIcon}}</v-icon>
                </v-avatar>
                {{item.transTitle}}
              </v-chip>
            </span>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
            v-if="this.opsNotiCompleted">
              <v-icon :color="ui.btnColorWarning">done</v-icon>
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
            v-if="result.basic.tag === 'O1'">
              <v-avatar>
                <v-icon>thumb_up</v-icon>
              </v-avatar>
              {{result.stats.nlike}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
            v-if="item.enableTime">
              <v-avatar>
                <v-icon>schedule</v-icon>
              </v-avatar>
              {{dateTimeAgo(result.stats.dcrt)}}
            </v-chip>
          </v-layout>
          <v-layout row v-if="result.basic.tag === 'B3'">
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>priority_high</v-icon>
              </v-avatar>
              {{result.char.pri}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>event</v-icon>
              </v-avatar>
              {{dateTypeA(result.stats.ddue)}}
            </v-chip>
          </v-layout>
          <v-layout class="mt-4">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> short_text </v-icon>
              </v-avatar>
              Description
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>{{item.extraIcon}}</v-icon>
              </v-avatar>
              {{item.extraTitle}}
            </v-chip>
          </v-layout>
          <v-layout class="ml-3 mr-3 mt-1">
            <div :class="ui.textSubheadingGrey">
              {{item.description}}
            </div>
          </v-layout>
          <v-layout class="mt-3 mr-3">
            <v-spacer/>
            <DocumentStatus :data="{
              model: 'SMALL',
              rev: this.displayDocumentRevTypeA(result.rev),
              sec: result.rev.sec,
              stat: result.rev.stat,
              type: result.rev.type}
              "/>
          </v-layout>
          <div v-if="this.enableExtraFeatures">
            <v-layout row class="mt-4">
              <v-spacer/>
              <GetTreePage v-if="this.result.basic.tag === 'A1'"
              :data="{
                did: this.result.basic.did,
                tag: 'A1.R',
                size: 'flat',
                type: null,
                item: this.result}"
              />
            </v-layout>
            <v-layout row class="mt-0" v-if="this.result.basic.tag === 'A1'">
              <v-spacer/>
              <OpsNew
              :data="{btnTitle: 'Ops', btnSize: 'flat', info: this.result}"
              v-if="this.getUser.pref.select.fauth !== null"/>
              <WorkRequestNew
              :data="{btnTitle: 'Work', btnSize: 'flat', info: this.result}"
              v-if="
              this.getUser.pref.select.fauth !== null && this.result.basic.tag === 'A1'
              "/>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            close
          </v-btn>
          <!-- <ArchiveDoc
          v-if="enableArchive"
          :data="{
            tag: this.result.basic.tag,
            size: 'icon',
            item: this.result}"
          /> -->
          <div
          v-if="enableArchive">
            <div v-if="this.btnSpinArchiveDoc == false">
              <v-btn :color="ui.bkgdColor" @click="archiveDocumentLocal()"
              icon>
                <v-icon :color="ui.btnColorWarning"> archive </v-icon>
              </v-btn>
            </div>
            <div v-else>
              <BtnSpin :btnSpec="btnInfo1"/>
            </div>
          </div>
          <v-spacer/>
          <GetDetailPage
          v-if="
          item.enableDetail &&
          this.enableAccessAuthEdit(this.result.basic.tag)"
          :data="{
            tag: this.result.basic.tag,
            size: 'flat',
            item: this.result}"
          />
          <GetSpecificPage
          v-if="
          item.enableDetailExtra &&
          (this.result.basic.tag === 'W1' || this.result.basic.tag === 'W2')
          "
          :data="{
            tag: this.result.basic.tag,
            page: '/worktooldetail',
            size: 'icon',
            item: this.result}"
          />
          <!-- <GetSpecificPage
          v-if="this.result.basic.tag === 'B3' && this.result.link.cdid === this.getUser.pref.select.cdid"
          :data="{
            tag: this.result.basic.tag,
            page: '/actiondetail',
            size: 'flat',
            item: this.result}"
          /> -->
          <v-btn :color="ui.colorWarning" flat dark
          v-if="this.result.basic.tag === 'B3' && this.result.link.cdid !== this.getUser.pref.select.cdid">
            <v-icon left>
              info
            </v-icon>
            Select Company
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import registerFunctions from "@/data/functions/mixins/registerFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import GetDetailPage from "@/support/detail/components/GetDetailPage";
// import ArchiveDoc from "@/document/archive/components/ArchiveDoc";
import GetTreePage from "@/asset/tree/components/GetTreePage";
import GetSpecificPage from "@/support/detail/components/GetSpecificPage";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";
import WorkRequestNew from "@/work/request/components/WorkRequestNew";
import OpsNew from "@/operations/notification/components/OpsNew";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
// import GetComms from "@/document/comms/components/GetComms";
import archiveFirebase from "@/data/cloud/firebase/mixins/archiveFirebase.js";

export default {
  mixins: [
    apptheme,
    dateFunctions,
    numberFunctions,
    storeFunctions,
    routerFunctions,
    describeDocument,
    displayFunctions,
    revFunctions,
    registerFunctions,
    accessFunctions,
    archiveFirebase
  ],
  components: {
    // GetComms,
    GetTreePage,
    GetDetailPage,
    GetSpecificPage,
    DocumentStatus,
    WorkRequestNew,
    // ArchiveDoc,
    OpsNew
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableExtraFeatures: false,
      btnSpinArchiveDoc: false,
      btnInfo1: {
        color: "red",
        icon: "home",
        name: "add user",
        btnType: "icon"
      }
    };
  },
  computed: {
    ...mapGetters([
      "getDataSource",
      "getSearchResults",
      "getPageTitle",
      "getCardOpen"
    ]),
    result() {
      return this.getSearchResults[this.listIndex];
    },
    tag() {
      let tag = this.result.basic.tag;
      return tag;
    },
    enableArchive() {
      let logic = null;
      let status = null;
      if (
        this.result.basic.tag !== "O1" &&
        this.result.basic.tag !== "E8" &&
        this.result.trans !== undefined
      ) {
        let flow = this.result.trans.flow;
        status = flow[flow.length - 1].title;
        if (status === "Closed" || status === "Cancelled") {
          if (this.result.basic.ver !== "A") {
            logic = true;
          } else {
            logic = false;
          }
        } else {
          logic = false;
        }
      } else {
        if (
          this.result.basic.tag === "O1" &&
          this.result.basic.tag !== "E8" &&
          this.result.char.stat === true &&
          this.result.basic.ver !== "A"
        ) {
          logic = true;
        } else {
          logic = false;
        }
      }

      return logic;
    },
    docIsArchived() {
      let logic = null;
      if (this.result.basic.ver === "A") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    opsNotiCompleted() {
      let logic = null;
      if (this.result.basic.tag === "O1") {
        if (this.result.char.stat === true) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    btnRegisterReadColor() {
      let color = null;
      let status = this.result.basic.list;
      if (status !== undefined && status !== null) {
        if (status === true) {
          color = this.ui.btnColorWarning;
        } else {
          color = this.ui.btnColor;
        }
      } else {
        color = this.ui.btnColor;
      }
      return color;
    },
    item() {
      let obj = {
        title: "",
        heading: "",
        textareaLabel: "",
        description: "",
        enableEscalate: false,
        enableDetail: false,
        enableTrans: true,
        enableTime: true,
        enableDetailExtra: false,
        transTitle: "",
        transIcon: "",
        extraTitle: "NA", // extra info
        extraIcon: "home", // extro icon
        icon: ""
      };
      if (this.result.trans !== null && this.result.trans !== undefined) {
        // eslint-disable-next-line
        obj.transTitle = this.result.trans.flow[this.result.trans.flow.length - 1].title;
        // eslint-disable-next-line
        obj.transIcon = this.result.trans.flow[this.result.trans.flow.length - 1].icon;
      }

      // DEFINE OBJ TAG
      obj.tag = this.result.basic.tag;

      if (this.result.basic.tag === "O1") {
        obj.title = "Ops Notification";
        obj.icon = "notifications";
        obj.textareaLabel = "Operations Observation";
        obj.description = this.result.char.des;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.enableTrans = false;
        obj.heading = this.result.basic.title;
      } else if (
        this.result.basic.tag === "W1" ||
        this.result.basic.tag === "B6.W1"
      ) {
        obj.title = "Work Request";
        obj.icon = "build";
        obj.description = this.result.char.des;
        obj.textareaLabel = "Work Description";
        obj.extraIcon = "grid_view";
        obj.extraTitle = this.result.char.type + " - " + this.result.char.dis;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        if (this.result.trans.level > 4) {
          obj.enableDetailExtra = true;
        }
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "W2") {
        obj.title = "Work Call";
        obj.icon = "handyman";
        obj.description = this.result.char.scope;
        obj.textareaLabel = "Call Description";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering";
      } else if (this.result.basic.tag === "W6") {
        obj.title = "Procedure";
        obj.icon = "assignment";
        obj.description = this.result.char.des;
        obj.textareaLabel = "Describtion and Objective";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.enableTrans = false;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.cat;
        obj.extraIcon = "apps_outage";
      } else if (this.result.basic.tag === "E6") {
        obj.title = "Technical Program";
        obj.icon = "science";
        obj.description = this.result.char.com;
        obj.textareaLabel = "Describtion and Objective";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.description = this.result.char.des;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering";
      } else if (this.result.basic.tag === "E8") {
        obj.title = "ITR Report";
        obj.icon = "add_chart";
        obj.description = "TEST TEST TEST";
        obj.textareaLabel = "Describtion and Objective";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.description = this.result.char.des;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering";
      } else if (this.result.basic.tag === "E1") {
        obj.title = "Equipment";
        obj.icon = "emoji_objects";
        obj.textareaLabel = "Engineering Description";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "E2") {
        obj.title = "Engineering Request";
        obj.icon = "settings";
        obj.textareaLabel = "Engineering Description";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering";
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "M2") {
        obj.title = "Maint. Strategy";
        obj.icon = "explore";
        obj.description = this.result.char.des;
        obj.textareaLabel = "Maintenance Strategy Description";
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "M5") {
        obj.title = "Maint. Plan";
        obj.icon = "settings";
        obj.textareaLabel = "Maintenance Strategy";
        obj.description = this.result.char.scope;
        obj.extraTitle = this.result.strategy.char.dis;
        obj.extraIcon = "engineering";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "M7") {
        obj.title = "Maint. Call";
        obj.icon = "work";
        obj.textareaLabel = "Maintenance Call";
        obj.description = this.result.char.call;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
      } else if (this.result.basic.tag === "L1") {
        obj.title = "Material";
        obj.icon = "category";
        obj.textareaLabel = "Material Description";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.enableTrans = false;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering"; // extro icon
        obj.description = this.result.char.des;
      } else if (this.result.basic.tag === "L2") {
        obj.title = "Bill of Material";
        obj.icon = "settings";
        obj.textareaLabel = "Engineering Description";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "A1") {
        obj.title = "Asset";
        obj.icon = "emoji_transportation";
        obj.textareaLabel = "Asset Description";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.enableTrans = false;
        obj.enableTime = false;
        obj.heading = this.result.basic.title;
        obj.extraTitle = this.result.char.dis;
        obj.extraIcon = "engineering"; // extro icon
        obj.description = this.result.char.des;
      } else if (this.result.basic.tag === "B1") {
        obj.title = "Risk";
        obj.icon = "emergency";
        obj.textareaLabel = "Risk Assessment";
        obj.extraTitle = this.result.char.theme;
        obj.extraIcon = "emergency";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "B4") {
        obj.title = "Budget";
        obj.icon = "savings";
        obj.textareaLabel = "Budget Preparation";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "B6") {
        obj.title = "Plan";
        obj.icon = "emergency";
        obj.textareaLabel = "Planning and Schedule";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
        obj.heading = this.result.basic.title;
        // eslint-disable-next-line
      } else if (this.result.basic.tag === "F1") {
        obj.title = "Facility";
        obj.icon = "emergency";
        obj.textareaLabel = "Planning and Schedule";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.enableTime = false;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
        obj.heading = this.result.basic.title;
        // eslint-disable-next-line
      } else if (this.result.basic.tag === "Q1") {
        obj.title = "Order";
        obj.icon = "assignment";
        obj.textareaLabel = "Order and Transactions";
        obj.description = this.result.char.des;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
        // eslint-disable-next-line
      } else if (this.result.basic.tag === "B3" || this.result.basic.tag === "U1.B3") {
        obj.title = "Action";
        obj.icon = "task";
        obj.textareaLabel = "Action";
        obj.description = this.result.char.scope;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.extraTitle = this.result.char.type;
        obj.extraIcon = "grid_view";
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "S1") {
        obj.title = "Hazard";
        obj.icon = "task";
        obj.extraTitle = this.result.char.theme;
        obj.extraIcon = "error_outline";
        obj.textareaLabel = "Hazard";
        obj.description = this.result.char.des;
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
      } else if (this.result.basic.tag === "S6") {
        obj.title = "Incident";
        obj.icon = "report";
        obj.extraTitle = this.result.char.found;
        obj.extraIcon = "local_fire_department";
        obj.description = this.result.char.des;
        obj.textareaLabel = "Incident";
        obj.enableEscalate = false;
        obj.enableDetail = true;
        obj.heading = this.result.basic.title;
      } else {
        obj.title = "Undefined";
      }

      // others
      return obj;
    }
  },
  // eslint-disable-next-line
  props: {
    listIndex: {
      type: Number
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.btnSpinGetDetail = false;
      this.enableExtraFeatures = true;
      // this.saveToStore(this.result);
      let did = this.result.basic.did;
      // change Orginal
      this.$store.dispatch("changeOriginal", this.result);
      if (this.tag === "A1") {
        // PREPARE FOR ASSET TREE
        let tree = this.generateTreeInfo(this.result.basic);
        let assetDID = this.result.basic.did;
        this.$store.dispatch("changeTreeInfo", tree);
        this.$store.dispatch("changeAssetDID", assetDID);
      } else if (this.tag === "B3" || this.tag === "U1.B3") {
        // used to detect changes
        this.$store.dispatch("changeAction", this.result);
        // Take DID from ACTION
        this.$store.dispatch("changeCompanyDID", this.result.link.cdid);
      } else if (this.tag === "C1") {
        this.$store.dispatch("changeCompanyDID", did);
      } else if (this.tag === "F1") {
        this.$store.dispatch("changeFacilityDID", did);
      } else {
        // do nothing
      }
    },
    archiveDocumentLocal() {
      console.log("ARCHIVE");
      console.log(this.result);
      this.archiveFirebaseDocument(this.result);
      this.dialog = false;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
